// AdminSiteSettings.jsx
import React, { useState } from 'react';
import '../styles/AdminSiteSettings.css';
import AdminSidebar from './AdminSidebar';

const AdminSiteSettings = () => {
    const [siteInfo, setSiteInfo] = useState({
        siteName: '',
        description: '',
        contactEmail: '',
        phone: '',
        address: '',
        logo: null,
        favicon: null,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSiteInfo((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setSiteInfo((prev) => ({ ...prev, [name]: files[0] }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // TODO: 파일 포함 설정 저장 API 연동
        console.log('사이트 정보 저장됨:', siteInfo);
    };

    return (
        <div className="admin-site-settings">
            <AdminSidebar />
            <div className="settings-content">
                <h2 className="setting-title">웹사이트 정보 설정</h2>
                <form onSubmit={handleSubmit} className="settings-form">
                    <label>사이트 이름:
                        <input type="text" name="siteName" value={siteInfo.siteName} onChange={handleChange} required />
                    </label>

                    <label>사이트 설명:
                        <textarea name="description" value={siteInfo.description} onChange={handleChange} rows={3} />
                    </label>

                    <label>대표 이메일:
                        <input type="email" name="contactEmail" value={siteInfo.contactEmail} onChange={handleChange} />
                    </label>

                    <label>대표 전화번호:
                        <input type="text" name="phone" value={siteInfo.phone} onChange={handleChange} />
                    </label>

                    <label>회사 주소:
                        <input type="text" name="address" value={siteInfo.address} onChange={handleChange} />
                    </label>

                    <label>로고 업로드:
                        <input type="file" name="logo" accept="image/*" onChange={handleFileChange} />
                    </label>

                    <label>파비콘 업로드:
                        <input type="file" name="favicon" accept="image/*" onChange={handleFileChange} />
                    </label>

                    <button type="submit" className="save-button">저장</button>
                </form>
            </div>
        </div>
    );
};

export default AdminSiteSettings;
